import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import OTDPAddon from './OTDPAddon'
import Text from 'components/common/Text/Text'
import styled from 'styled-components'

const OTDPAddons = ({
  value,
  mandatoryItems,
  optionalItems,
  mandatoryValues,
  handleChange,
  quantity,
  commerceItemId,
  enableEdit
}) =>
  <Fragment>
    {
      mandatoryItems.concat(optionalItems).map(({
        label,
        value: checkboxValue,
        name,
        price,
        brand,
        isMandatory
      }, index) => (
        <Fragment key={ index }>
          <OTDPAddon
            mandatory={ isMandatory }
            mandatoryValues={ mandatoryValues }
            quantity={ quantity }
            brand={ brand }
            price={ price }
            key={ index }
            name={ name }
            label={ label }
            commerceItemId={ commerceItemId }
            canBeEdited={ enableEdit }
            value={ value && value.includes(checkboxValue) }
            onChange={ e => handleChange(checkboxValue, e.target.checked) } />
          {
            Boolean(optionalItems.length) &&
            index === (mandatoryItems.length - 1) &&
            <OptionalHeader headline size={ 16 }>
              { enableEdit ? 'Optional' : 'Option Selected' }
            </OptionalHeader>
          }
        </Fragment>
      ))
    }
  </Fragment>

OTDPAddons.propTypes = {
  commerceItemId: PropTypes.string,
  enableEdit: PropTypes.bool,
  handleChange: PropTypes.func,
  mandatoryItems: PropTypes.arrayOf(PropTypes.object),
  mandatoryValues: PropTypes.arrayOf(PropTypes.string),
  optionalItems: PropTypes.arrayOf(PropTypes.object),
  quantity: PropTypes.number,
  value: PropTypes.arrayOf(PropTypes.string)
}

export default OTDPAddons


const OptionalHeader = styled(Text)`
  margin: 20px 0 0;
`
